<template>
  <div
    class="divProjectDisplay"
    v-if="items.length > 0"
    :class="{ btnButtonMsg: msgInfo }"
  >
    <div
      class="divBtn"
      v-for="(item, index) in items"
      :key="index"
      @click="linkClick(item.url, item.isImgCode)"
      :style="{
        background: item.url && lastDay < 0 ? btnInitColor : notUseColor,
      }"
    >
      <div
        class="divBg"
        :style="{
          background: item.url && lastDay < 0 ? btnHoverColor : notUseColor,
        }"
      ></div>
      <div class="divContent">
        <img
          :src="item.isImgCode ? appUrl : pcUrl"
          :class="{ appImg: item.isImgCode, pcImg: !item.isImgCode }"
        />{{ item.title }}
      </div>
      <div class="divCodeImg" v-if="item.isImgCode && item.url" style="color: #000">
        <img :src="item.url" alt />
        <p>{{ item.user }}</p>
        <p>{{ item.pwd }}</p>
      </div>
      <div
        class="divMsg"
        v-if="!item.isImgCode && (item.user || item.pwd) && item.url"
      >
        <p>{{ item.user }}</p>
        <p>{{ item.pwd }}</p>
      </div>
    </div>
    <div class="divMsgInfo" v-if="msgInfo">{{ msgInfo }}</div>
  </div>
</template>

<script>
let moment = require("moment");
moment.locale("zh-cn");
export default {
  props: {
    links: {
      type: Array,
      default: () => [],
    },
    btnHoverColor: {
      //鼠标悬浮之后的颜色
      type: String,
      default: "#0368d9",
    },
    btnInitColor: {
      //默认颜色
      type: String,
      default: "#0078ff",
    },
    lastUpdate: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pcUrl: require("./../img/pc.png"),
      appUrl: require("./../img/app.png"),
      notUseColor: "#d4dfec",
    };
  },
  computed: {
    items() {
      let items = [];
      console.log(8989, this.links)
      if (this.links.length > 0) {
        this.links.forEach((item) => {
          items.push({
            isImgCode: this.isImgCode(item.url),
            url: this.convertUrl(item.url),
            title: item.title,
            user: this.getUser(item.info),
            pwd: this.getPwd(item.info),
          });
        });
      }
      return items;
    },
    //diff可以理解成减号  <0表示前边的小在今天之前  >0表示前边的大在今天之后
    lastDay() {
      return moment(this.lastUpdate).diff(moment(), "days");
    },
    msgInfo() {
      if (this.lastDay > 0) {
        return "项目即将发布，敬请期待...";
      }
      let flag = false;
      this.links.forEach((item) => {
        if (!item.url) {
          flag = true;
          return;
        }
      });
      if (flag) {
        return "项目升级中，敬请期待...";
      }
      return "";
    },
  },
  methods: {
    getUser(str) {
      let user = "";
      if (str) {
        let index = str.indexOf("密");
        user = str.substr(0, index);
      }
      return user;
    },
    getPwd(str) {
      let pwd = "";
      if (str) {
        let index = str.indexOf("密");
        pwd = str.substr(index);
      }
      return pwd;
    },
    convertUrl(url) {
      let realUrl = url;
      if (url && url.indexOf("http://") < 0) {
        realUrl = "http://" + url;
      }
      return realUrl;
    },
    isImgCode(url) {
      let flag = false;
      const imgList = ["png", "jpg", "jpeg", "bmp", "gif"];
      if (url) {
        let arr = url.split(".");
        if (arr.length > 0) {
          let suffix = arr[arr.length - 1].toLowerCase();
          if (imgList.find((item) => item === suffix)) {
            flag = true;
          }
        }
      }
      return flag;
    },
    linkClick(url, flag) {
      if (url && !flag && this.lastDay < 0 ) {
        window.open(url, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/displayButtonWidge";
</style>
